module.exports = __webpack_public_path__ + "static/media/washTshirt.5e1e44ee.svg";